import { useRef, useState } from 'react';
import { Button, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Brands from '../users/Brands';
import { formatAgeString, getGender, getMaximumKey, getRandomColor, getTop10Records, toAudiencePercent } from '../../utils/common';
import { COUNTRY_JSON, TOOLTIP_STYLES, YOUTUBE_TYPE, getDecimal, getFixedValue, gettwoDigitFixedValue, getDateformatUsingSeconds, gradientText, hideScrollbarCss, mainGradient } from '../../utils/constant';
import profilePlatformIcon from '../../assets/images/icons/profilePlatformIcon.svg'
import engagementIcon from '../../assets/images/icons/dashboardEne.svg'
import imageIcon from '../../assets/images/icons/imageIconBlack.svg'
import usersIcon from '../../assets/images/icons/dashboardUser.svg'
import growthIcon from '../../assets/images/icons/growthIcon.svg'
import tagIcon from '../../assets/images/icons/tagIcon.svg'
import exitIcon from '../../assets/images/icons/logouticon.svg'
import voiceIcon from '../../assets/images/icons/voiceIcon.svg'
import chartIcon from '../../assets/images/icons/chartIcon.svg'
import trendingUpIcon from '../../assets/images/icons/trendingUpIcon.svg'
import dummyProfileOverallScore from '../../assets/images/icons/dummyProfileOverallScore.png'
import dummyProfileInflyxScore from '../../assets/images/icons/dummyProfileInflyxScore.png'
import dummyProfileEngagementScore from '../../assets/images/icons/dummyProfileEngagementBar.png'
import profileReelIcon from '../../assets/images/icons/profileReelIcon.svg'
import profileCommentIcon from '../../assets/images/icons/profileCommentIcon.svg'
import likeIcon from '../../assets/images/icons/likeIcon.svg'
import eyeIcon from '../../assets/images/icons/openEye.svg'
import mapPinIcon from '../../assets/images/icons/mapPinIcon.png'
import navigationIcon from '../../assets/images/icons/navigationIcon.svg'
import globeIcon from '../../assets/images/icons/globeIcon.svg'
import cakeIcon from '../../assets/images/icons/cakeIcon.svg'
import certificateIcon from '../../assets/images/icons/certificateBadgeIcon.svg'
import { Bar } from 'react-chartjs-2';
import maleIcon from '../../assets/images/icons/maleIcon.svg'
import femaleIcon from '../../assets/images/icons/femaleIcon.svg'
import infoIcon from '../../assets/images/icons/infoIcon.svg'
import { useSelector } from 'react-redux';

function LinearProgressWithLabel({ country, value, ...rest }) {
  // `value` is a 0-100 percentage, or null when the figure isn't trustworthy.
  const hasValue = value !== null && value !== undefined;
  const barValue = Math.min(100, Math.max(0, Number(value) || 0));
  return (
    <Box className="barListItem">
      <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
        <Typography fontSize={12} fontWeight={400} color={"black"}>{country}</Typography>
        <Typography fontSize={12} fontWeight={400} color={"black"}> {hasValue ? `  ${getDecimal(value)}%` : '  —'}</Typography>
      </Stack>
      <Stack className='d-flex align-items-center' style={{ flexDirection: 'row', height: '12px' }}>
        <LinearProgress {...rest} variant="determinate" value={hasValue ? barValue : 0}
          sx={{
            width: '100%',
            height: 8, marginTop: '5px',
            borderRadius: 8,
            "& .MuiLinearProgress-bar": {
              borderRadius: 8,
              backgroundColor: getRandomColor(),
            },
            backgroundColor: "#eee"
          }} />
        &nbsp;
      </Stack>
    </Box>
  );
}

const CommingSoonUi = ({ breakLine = false }) => {
  return (
    <Stack justifyContent={"center"} alignItems={"center"} sx={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "8px",
      border: "2px solid transparent",
      borderImage: `${mainGradient} 1 / / rounded`,
      backgroundColor: "rgba(250, 250, 250, 0.6)",
      backdropFilter: "blur(8px)",
      display: 'flex',
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Typography sx={{ ...gradientText, textAlign: 'center', fontSize: '48px', fontWeight: 700, }}>Coming {breakLine && <br />} Soon</Typography>
    </Stack>
  )
}

const EngagementInfoCard = ({ image, value, text }) => {
  return (
    <Stack direction={"column"} padding={"16px 10px"} borderRadius={'10px'} border="1px solid #F0F0F0" justifyContent={"space-between"} alignItems={"center"} height={'136px'} width={"100%"}>
      <img src={image} alt="EngagementInfoCard" style={{ height: '24px', width: '24px' }} />
      <Typography fontSize={20} fontWeight={600} color={"black"}>{value}</Typography>
      <Typography fontSize={14} fontWeight={400} color="#726C6C">{text}</Typography>
    </Stack>
  )
}

const LocationCard = ({ image, text, value }) => {
  return (
    <Stack height={"126px"} width={"250px"} direction={"column"} padding={"24px 12px"} border={"1px solid #EEE"} borderRadius={'6px'} justifyContent={"space-between"} alignItems={"flex-start"}>
      <img src={image} alt="icon" style={{ width: '24px', height: '24px' }} />
      <Typography fontSize={12} fontWeight={400} color={"#726C6C"}>{text}</Typography>
      <Typography fontSize={16} fontWeight={500} color={"#000000"}>{value}</Typography>
    </Stack>
  )
}

const UltimateSocialProfileSummary = ({ data, influencerDetails }) => {
  const [audienceTab, setAudienceTab] = useState("city");
  const [postTab, setPostTab] = useState("topMostPost");
  const [showAllHastags, setShowAllHastags] = useState(false);
  const [childElementIdForScroll, setChileElementIdForScroll] = useState("#overview")
  const links = [
    { label: 'Overview', href: '#overview', icon: profilePlatformIcon },
    { label: 'Engagement', href: '#engagement', icon: engagementIcon },
    { label: 'Content', href: '#content', icon: imageIcon },
    { label: 'Audience', href: '#audience', icon: usersIcon },
    { label: 'Growth', href: '#growth', icon: growthIcon },
    { label: 'Brands', href: '#brands', icon: tagIcon },
  ];
  const contentRef = useRef(null);
  const { isScreenZoomed } = useSelector(state => state.commonSlice);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
      slidesToSlide: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: isScreenZoomed ? 4 : 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const isYoutube = data?.platformType === 'youtube';

  const getProfileUrl = () => {
    if (data?.platformType === 'instagram') {
      return influencerDetails?.profile_url || `https://instagram.com/${data?.handleName}/`;
    }
    return `https://youtube.com/${data?.handleName}/`;
  }

  const labelsForAgeGroupGraph = data?.Audience?.age_group?.map(item => Object.keys(item)[0]) || [];
  const valuesForAgeGroupGraph = data?.Audience?.age_group?.map(item => Object.values(item)[0]) || [];
  const totalForAgeGroupGraph = valuesForAgeGroupGraph.reduce((acc, val) => acc + val, 0);
  const percentages = valuesForAgeGroupGraph.map(val => ((val / totalForAgeGroupGraph) * 100).toFixed(2));

  const dataForAgeGroupGraph = {
    labels: labelsForAgeGroupGraph,
    datasets: [
      {
        label: "Audience Age Group (%)",
        data: percentages,
        backgroundColor: "#0077FF",
        borderRadius: 6,
        maxBarThickness: 40
      },
    ],
  };

  function getGenderStats(genderData = []) {
    let male = 0;
    let female = 0;
    genderData.forEach(item => {
      male += item.Male || item.m || item.male || item.M || 0;
      female += item.Female || item.f || item.female || item.F || 0;
    });
    const total = male + female;
    const malePercent = total ? ((male / total) * 100).toFixed(2) : 0;
    const femalePercent = total ? ((female / total) * 100).toFixed(2) : 0;
    return [
      { gender: "Male", value: male, percentage: Number(malePercent) },
      { gender: "Female", value: female, percentage: Number(femalePercent) }
    ];
  }

  const GENDER_AUDIANCE_GRAPH_DATA = getGenderStats(data?.Audience?.gender);

  const getGrowthRate = () => {
    const growth = data?.Audience?.growth || data?.creator_follower_growth;
    if (!growth) return "N/A";
    if (typeof growth === 'object') {
      return Object.values(growth)[0]?.toFixed(2) + "%" || "N/A";
    }
    return parseFloat(growth)?.toFixed(2) + "%" || "N/A";
  }

  const hashtags = data?.content?.hashtags || [];
  const deduplicatedHashtags = hashtags.reduce((acc, h) => {
    const existing = acc.find(x => x.text === (h?.text || ''));
    if (existing) {
      existing.value += (h?.value || 0);
    } else {
      acc.push({ text: h?.text || '', value: h?.value || 0 });
    }
    return acc;
  }, []);

  const onSmoothClick = (e, href) => {
    const id = href.replace("#", "")
    const parentEle = document.getElementById('parent');
    const childEle = document.getElementById(id);
    setChileElementIdForScroll('#' + id);
    if (parentEle && childEle) {
      parentEle.scrollTop = childEle.offsetTop
      e.preventDefault()
      parentEle.scrollIntoView({
        behavior: "smooth",
      })
    }
  }

  return (
    <>
      <Stack direction={"row"} padding={'0px 16px'} position={"relative"} sx={{ height: isScreenZoomed ? '65vh' : '69vh' }}>
        <Box sx={{ width: '15%', height: '100%', position: 'sticky', top: 0, paddingTop: '20px' }}>
          <Stack direction={"column"} gap={2}>
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => onSmoothClick(e, l.href)}
                style={{ display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }}
              >
                <img src={l.icon} alt={l.icon} style={{
                  height: '20px', width: '20px', filter:
                    childElementIdForScroll === l.href
                      ? "brightness(0) saturate(100%) invert(38%) sepia(95%) saturate(7485%) hue-rotate(202deg) brightness(103%) contrast(104%)"
                      : "brightness(0)",
                }} />
                <Typography fontSize={16} fontWeight={400} color={childElementIdForScroll === l.href ? "var(--color-blue)" : 'black'}>{l.label}</Typography>
              </a>
            ))}
            <a href="#/" style={{ color: 'black', display: 'flex', flexDirection: 'row', gap: '10px', textDecoration: 'none', alignItems: 'center' }} onClick={(e) => { e.preventDefault(); window.open(getProfileUrl(), "_blank"); }} target='_blank'>
              <img src={exitIcon} alt={exitIcon} style={{ height: '18px', width: '18px' }} />
              {isYoutube ? "Open Youtube" : "Open Instagram"}
            </a>
          </Stack>
        </Box>
        <Box sx={{
          width: '85%', height: '100%', overflowY: 'scroll', position: 'relative', borderLeft: '1px solid #F0F0F0',
          scrollBehavior: 'smooth', overscrollBehavior: 'contain', padding: '0px 20px 0 40px'
        }} id="parent" ref={contentRef} >
          <Box id='overview' paddingTop={'20px'}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={profilePlatformIcon} style={{ width: '24px', height: '24px' }} alt={profilePlatformIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Overview</Typography>
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', marginTop: '40px', gap: '16px' }} direction={"row"}>
              <Stack
                sx={{
                  width: "75%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={voiceIcon} alt="voiceIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>{isYoutube ? "Total Videos" : "Estimated Reach"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{isYoutube ? (data?.video_count || "N/A") : (parseInt(data?.Audience?.reach) ? getFixedValue(data?.Audience?.reach) : "N/A")}</Typography>
                    {!isYoutube && <Typography fontSize={12} fontWeight={400} color={"#726C6C"}>per 30 days</Typography>}
                  </Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={engagementIcon} alt="engagementIcon" style={{ height: '30px', width: '30px', }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{isYoutube ? "AVG. VIEWS" : "ENGAGEMENT RATE"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>
                      {isYoutube
                        ? getFixedValue(data?.Engagement?.posts?.avg_views)
                        : (data?.overview?.engagement_rate ? Number(data.overview.engagement_rate).toFixed(2) + "%" : "N/A")
                      }
                    </Typography>
                    <Typography fontSize={12} fontWeight={400} color={"#726C6C"}>per 30 days</Typography>
                  </Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={usersIcon} alt="usersIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>{isYoutube ? "SUBSCRIBERS" : "Followers"}</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{getFixedValue(data?.followers) || "N/A"}</Typography>
                  </Stack>
                </Box>
                <Box sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px', display: 'none' }}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    <img src={chartIcon} alt="chartIcon" style={{ height: '30px', width: '30px' }} />
                    <Typography sx={{ padding: '4px 8px', fontSize: '12px', fontWeight: 600, color: '#CE1111', background: '#FCDFDF', borderRadius: '20px', display: 'none' }}>Low</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>Quality Audience</Typography>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.followers ? "75%" : "N/A"}</Typography>
                    <Typography fontSize={12} fontWeight={500} color={"#726C6C"}>{getFixedValue(data?.followers) || "N/A"}</Typography>
                  </Stack>
                </Box>
              </Stack>
              <Box sx={{ width: '25%', position: 'relative' }}>
                <img src={dummyProfileOverallScore} alt="dummyProfileOverallScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={true} />
              </Box>
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', marginTop: '40px', gap: '16px' }} direction={"row"}>
              <Box sx={{ width: '25%', position: 'relative' }}>
                <img src={dummyProfileInflyxScore} alt="dummyProfileInflyxScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={true} />
              </Box>
              <Box sx={{ width: '75%', position: 'relative' }}>
                <img src={dummyProfileEngagementScore} alt="dummyProfileEngagementScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={false} />
              </Box>
            </Stack>
          </Box>
          <Box id='engagement' paddingTop={'60px'}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={engagementIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Engagement & Views</Typography>
            </Stack>
            <Stack direction={'row'} gap={2} marginTop={'40px'}>
              <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                  <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                    <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} />
                    <Typography fontSize={16} fontWeight={500} color={"black"}>{isYoutube ? "Video" : "Posts"}</Typography>
                  </Stack>
                  <Stack direction={"column"} gap={4} justifyContent={"flex-start"}>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.posts?.avg_comments) || "N/A"} text="Avg. Comments" />
                      <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.posts?.avg_likes) || "N/A"} text="Avg. Likes" />
                    </Stack>
                    {!isYoutube && <>
                      <Stack direction={"row"} gap={2} width={"100%"}>
                        <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.posts?.engagement_rate > 0 ? Number(data.Engagement.posts.engagement_rate).toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                        <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.posts?.estimated_reach > 0 ? getFixedValue(data.Engagement.posts.estimated_reach) : "N/A"} text="Estimated Reach" />
                      </Stack>
                    </>}
                    {isYoutube && <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.posts?.avg_views) || "N/A"} text="Avg. Views" />}
                  </Stack>
                </Box>
              </Box>
              {!isYoutube && <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                  <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                    <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} />
                    <Typography fontSize={16} fontWeight={500} color={"black"}>Reels</Typography>
                  </Stack>
                  <Stack direction={"column"} gap={2} justifyContent={"space-between"}>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.reels?.avg_views) || "N/A"} text="Avg. Views" />
                      <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.reels?.avg_likes) || "N/A"} text="Avg. Likes" />
                      <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.reels?.avg_comments) || "N/A"} text="Avg. Comments" />
                    </Stack>
                    <Stack direction={"row"} gap={2} width={"100%"}>
                      <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.reels?.engagement_rate > 0 ? Number(data.Engagement.reels.engagement_rate).toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                      <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.reels?.view_rate ? Number(data.Engagement.reels.view_rate).toFixed(2) + "%" : "N/A"} text="View Rate" />
                    </Stack>
                  </Stack>
                </Box>
              </Box>}
            </Stack>
            <Stack sx={{ height: '340px', width: '100%', marginTop: '40px', gap: '16px' }} direction={"row"}>
              <Stack
                sx={{
                  width: "75%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.overview?.likesToCommentsRatio ? Number(data.overview.likesToCommentsRatio).toFixed(2) : "N/A"}</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>Likes - Comments Ratio</Typography>
                </Stack>
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>
                      {!isYoutube
                        ? (data?.overview?.reelViewsToFollowersRatio ? Number(data.overview.reelViewsToFollowersRatio).toFixed(2) : "N/A")
                        : (data?.overview?.recurringViewership ? Number(data.overview.recurringViewership).toFixed(2) : "N/A")
                      }
                    </Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>
                    {!isYoutube ? "Reel views to followers ratio" : "RECURRING VIEWERSHIP"}
                  </Typography>
                </Stack>
                <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>
                      {!isYoutube
                        ? (data?.overview?.postFrequency ? Number(data.overview.postFrequency).toFixed(2) : "N/A")
                        : (data?.overview?.abilitytotriggerConversation ? Number(data.overview.abilitytotriggerConversation).toFixed(2) : "N/A")
                      }
                    </Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C', textTransform: 'capitalize' }}>
                    {!isYoutube ? "Post frequency" : "ABILITY TO TRIGGER CONVERSATIONS IN COMMENTS"}
                  </Typography>
                </Stack>
                {isYoutube && <Stack justifyContent={"space-between"} sx={{ width: "calc(50% - 8px)", height: "calc(50% - 8px)", border: "1px solid #F0F0F0", padding: '20px', borderRadius: '8px' }}>
                  <Stack direction={"row"} gap={1} alignItems={"flex-end"} marginTop={"10px"}>
                    <Typography fontSize={32} fontWeight={600} color={"black"} lineHeight={1}>{data?.overview?.likabilityOfTheVideo ? Number(data.overview.likabilityOfTheVideo).toFixed(2) : "N/A"}</Typography>
                  </Stack>
                  <Typography sx={{ marginTop: '6px', fontSize: '14px', fontWeight: 400, color: '#726C6C' }}>LIKABILITY OF THE VIDEO</Typography>
                </Stack>}
              </Stack>
              <Box sx={{ width: '25%', position: 'relative' }}>
                <img src={dummyProfileOverallScore} alt="dummyProfileOverallScore" style={{ width: '100%', height: '100%' }} />
                <CommingSoonUi breakLine={true} />
              </Box>
            </Stack>
            {!isYoutube && <>
              <Stack direction={"row"} gap={1} alignItems={"center"} paddingTop={"60px"}>
                <img src={engagementIcon} style={{ width: '24px', height: '24px' }} alt={engagementIcon} />
                <Typography fontSize={20} fontWeight={600} color={"black"}>PAID PARTNERSHIPS - ENGAGEMENTS & VIEWS</Typography>
              </Stack>
              <Stack direction={'row'} gap={2} marginTop={'40px'}>
                <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                  <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                      <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} />
                      <Typography fontSize={16} fontWeight={500} color={"black"}>Posts</Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"center"} gap={4} flexWrap={"wrap"}>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.total) || "N/A"} text="Total Posts" />
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.avg_comments) || "N/A"} text="Avg. Comments" />
                      </Stack>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.paid_partnerships?.posts?.engagement_rate > 0 ? Number(data.Engagement.paid_partnerships.posts.engagement_rate).toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                        <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.posts?.avg_likes) || "N/A"} text="Avg. Likes" />
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
                <Box sx={{ width: '50%', borderRadius: '8px', padding: '2px', background: mainGradient }}>
                  <Box sx={{ height: '100%', width: '100%', borderRadius: '6px', padding: '20px', background: 'white' }}>
                    <Stack direction={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1} marginBottom={'30px'}>
                      <img src={profileReelIcon} alt="profileReelIcon" style={{ height: '20px', width: '20px' }} />
                      <Typography fontSize={16} fontWeight={500} color={"black"}>Reels</Typography>
                    </Stack>
                    <Stack direction={"row"} justifyContent={"space-between"} flexWrap={"wrap"} gap={4}>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.total) || "N/A"} text="Total Reels" />
                        <EngagementInfoCard image={eyeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_views) || "N/A"} text="Avg. Views" />
                        <EngagementInfoCard image={likeIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_likes) || "N/A"} text="Avg. Likes" />
                      </Stack>
                      <Stack direction={"row"} width={"100%"} gap={2}>
                        <EngagementInfoCard image={profileCommentIcon} value={getFixedValue(data?.Engagement?.paid_partnerships?.reels?.avg_comments) || "N/A"} text="Avg. Comments" />
                        <EngagementInfoCard image={engagementIcon} value={data?.Engagement?.paid_partnerships?.reels?.engagement_rate > 0 ? Number(data.Engagement.paid_partnerships.reels.engagement_rate).toFixed(2) + "%" : "N/A"} text="Engagement Rate" />
                        <EngagementInfoCard image={eyeIcon} value={data?.Engagement?.paid_partnerships?.reels?.view_rate ? Number(data.Engagement.paid_partnerships.reels.view_rate).toFixed(2) + "%" : "N/A"} text="View Rate" />
                      </Stack>
                    </Stack>
                  </Box>
                </Box>
              </Stack>
            </>}
          </Box>
          <Box id="audience" paddingTop="60px">
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={usersIcon} style={{ width: '24px', height: '24px' }} alt={usersIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Audience</Typography>
            </Stack>
            <Stack direction={"row"} justifyContent={"flex-start"} gap={2} alignItems={"center"} paddingTop="40px">
              <LocationCard image={mapPinIcon} text={"Top City"} value={data?.Audience?.cities?.length > 0 ? getMaximumKey(data?.Audience?.cities) : "N/A"} />
              {!isYoutube && <LocationCard image={navigationIcon} text={"Top State"} value={data?.Audience?.state?.length > 0 ? getMaximumKey(data?.Audience?.state) : "N/A"} />}
              <LocationCard image={globeIcon} text={"Top Country"} value={data?.Audience?.country?.length > 0 ? (getMaximumKey(data?.Audience?.country) || "N/A") : "N/A"} />
              <LocationCard image={usersIcon} text={"Top Gender"} value={data?.Audience?.gender?.length > 0 ? getGender(getMaximumKey(data?.Audience?.gender?.filter((v, i) => v['U'] === undefined))) : "N/A"} />
              <LocationCard image={cakeIcon} text={"Top Age Group"} value={data?.Audience?.age_group?.length > 0 ? formatAgeString(getMaximumKey(data?.Audience?.age_group)) + " Years" : "N/A"} />
              <LocationCard image={certificateIcon} text={"Audience Quality"} value={data?.income_last_90_days_min && data?.income_last_90_days_max ? `$${data.income_last_90_days_min}-$${data.income_last_90_days_max} ${data?.income_currency || 'USD'}` : "N/A"} />
            </Stack>
            {(data?.Audience?.gender?.length > 0 || data?.Audience?.age_group?.length > 0) && <Stack sx={{ height: '340px', width: '100%', marginTop: '40px', gap: '16px' }} direction={"row"}>
              {data?.Audience?.age_group?.length > 0 && <Stack
                sx={{
                  width: "65%",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
                direction="row">
                <Box sx={{ height: '100%', width: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px' }}>
                  <Typography fontSize={16} fontWeight={500} color={"black"}>Audience Age Group</Typography>
                  <Box height={"100%"} width={"100%"} paddingY={"20px"}>
                    <Bar datasetIdKey='id'
                      data={dataForAgeGroupGraph} options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                          title: {
                            display: true,
                            text: "Audience Age Group",
                            padding: { top: 8, bottom: 16 },
                          },
                          datalabels: {
                            anchor: "end",
                            align: "end",
                            formatter: (value) => `${value}%`,
                            font: { weight: "600", size: 12 },
                            color: "#444",
                          },
                          tooltip: {
                            callbacks: {
                              label: (context) => `${context.raw}%`,
                            },
                          },
                        },
                        scales: {
                          x: {
                            grid: { display: false, drawBorder: false },
                            ticks: { display: true },
                          },
                          y: {
                            beginAtZero: true,
                            max: 100,
                            ticks: {
                              stepSize: 20,
                              callback: (v) => `${v}%`,
                            },
                            grid: {
                              display: true,
                              drawBorder: false,
                              drawTicks: false,
                              color: "#e6e6e6",
                              borderDash: [6, 6],
                              borderDashOffset: 0,
                              lineWidth: 1,
                            },
                          },
                        },
                      }}
                    />
                  </Box>
                </Box>
              </Stack>}
              {data?.Audience?.gender?.length > 0 && <Box sx={{ width: '35%', position: 'relative', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', height: '100%' }}>
                <Typography fontSize={16} fontWeight={500} color={"black"}>Audience Gender</Typography>
                <Stack direction={"row"} width={"100%"} height={"100%"}>
                  <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} gap={3} sx={{ padding: '0', margin: 0, width: '50%', height: '100%' }}>
                    <Box sx={{ position: "relative", width: 176, height: 176 }}>
                      <svg viewBox="0 0 36 36" style={{ width: "100%", height: "100%" }}>
                        <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" style={{ fill: "none", stroke: "#D9D9D9", strokeWidth: 3.4 }} />
                        <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" style={{ fill: "none", stroke: "#45B3AC", strokeWidth: 3.4, strokeLinecap: "round", transition: "stroke-dasharray 1s ease-out", strokeDasharray: `${GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}, 100` }} />
                      </svg>
                      <Box sx={{ position: "absolute", inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <img src={maleIcon} alt="icon" style={{ width: "31px", height: "64px" }} />
                        <Typography fontSize={20} fontWeight={600} color={'black'}>
                          {GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}%
                        </Typography>
                      </Box>
                    </Box>
                    <Stack direction={'row'} gap={1} justifyContent={"center"} alignItems={"center"}>
                      <Box sx={{ height: '10px', width: '10px', background: '#45B3AC', borderRadius: '50%' }}></Box>
                      <Typography fontSize={20} fontWeight={500} color={'black'}>{GENDER_AUDIANCE_GRAPH_DATA?.[0]?.percentage || 0}% <span style={{ fontSize: '14px', fontWeight: 400 }}>Male</span></Typography>
                    </Stack>
                  </Stack>
                  <Stack direction={"column"} justifyContent={"center"} alignItems={"center"} gap={3} sx={{ padding: '0', margin: 0, width: '50%', height: '100%' }}>
                    <Box sx={{ position: "relative", width: 176, height: 176 }}>
                      <svg viewBox="0 0 36 36" style={{ width: "100%", height: "100%" }}>
                        <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" style={{ fill: "none", stroke: "#D9D9D9", strokeWidth: 3.4 }} />
                        <path d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" style={{ fill: "none", stroke: "#F72585", strokeWidth: 3.4, strokeLinecap: "round", transition: "stroke-dasharray 1s ease-out", strokeDasharray: `${GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}, 100` }} />
                      </svg>
                      <Box sx={{ position: "absolute", inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <img src={femaleIcon} alt="icon" style={{ width: "31px", height: "64px" }} />
                        <Typography fontSize={20} fontWeight={600} color={'black'}>
                          {GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}%
                        </Typography>
                      </Box>
                    </Box>
                    <Stack direction={'row'} gap={1} justifyContent={"center"} alignItems={"center"}>
                      <Box sx={{ height: '10px', width: '10px', background: '#F72585', borderRadius: '50%' }}></Box>
                      <Typography fontSize={20} fontWeight={500} color={'black'}>{GENDER_AUDIANCE_GRAPH_DATA?.[1]?.percentage || 0}% <span style={{ fontSize: '14px', fontWeight: 400 }}>Female</span></Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>}
            </Stack>}
            {(data?.Audience?.state?.length > 0 || data?.Audience?.country?.length > 0 || data?.Audience?.cities?.length > 0) && <Box sx={{ height: '340px', width: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', overflow: 'hidden', marginTop: '40px' }}>
              <Stack direction={"row"} justifyContent={"space-between"} background={"white"} zIndex={2} paddingBottom={"15px"}>
                <Typography fontSize={16} fontWeight={500} color={"black"}>AUDIENCE GEOGRAPHY</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', border: '1px solid #EEE', padding: '4px', borderRadius: '4px' }}>
                  <Stack direction="row" spacing={1}>
                    <Button onClick={() => setAudienceTab("city")} sx={{ color: audienceTab === "city" ? "white" : 'black', background: audienceTab === "city" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } } }}>
                      <Typography fontSize={12} fontWeight={500} color={audienceTab === "city" ? "white" : 'black'}>City</Typography>
                    </Button>
                    <Button onClick={() => setAudienceTab("state")} sx={{ color: audienceTab === "state" ? "white" : 'black', background: audienceTab === "state" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } } }}>
                      <Typography fontSize={12} fontWeight={500} color={audienceTab === "state" ? "white" : 'black'}>State</Typography>
                    </Button>
                    <Button onClick={() => setAudienceTab("country")} sx={{ color: audienceTab === "country" ? "white" : 'black', background: audienceTab === "country" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } } }}>
                      <Typography fontSize={12} fontWeight={500} color={audienceTab === "country" ? "white" : 'black'}>Country</Typography>
                    </Button>
                  </Stack>
                </Box>
              </Stack>
              <Stack direction={"row"} justifyContent={"space-between"} gap={"20px"} flexWrap={"wrap"} zIndex={0} position={"relative"} height={"240px"} sx={{ overflowY: 'scroll', overflowX: 'hidden', ...hideScrollbarCss }}>
                {audienceTab === 'state' && (data?.Audience?.state?.length > 0 ? getTop10Records(data?.Audience?.state)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  // The API already returns 0-100 percentages. Do NOT renormalize over the
                  // top-10 sum — that inflates each value (e.g. Kolkata 29% would wrongly
                  // display as 57%).
                  const percentage = toAudiencePercent(value);
                  return <Box sx={{ width: 'calc(50% - 10px)' }} key={i}><LinearProgressWithLabel value={percentage} country={key} /></Box>
                }) : <span>No Data Found</span>)}
                {audienceTab === 'city' && (data?.Audience?.cities?.length > 0 ? getTop10Records(data?.Audience?.cities)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  const percentage = toAudiencePercent(value);
                  return <Box sx={{ width: 'calc(50% - 10px)' }} key={i}><LinearProgressWithLabel value={percentage} country={key} /></Box>
                }) : <span>No Data Found</span>)}
                {audienceTab === 'country' && (data?.Audience?.country?.length > 0 ? getTop10Records(data?.Audience?.country)?.map((obj, i) => {
                  const key = Object.keys(obj)[0];
                  const value = obj[key];
                  // The backend keys audience countries by name (e.g. "India"), like city/state.
                  // Keep the ISO-code lookup as a fallback for any code-keyed data, else show the
                  // name as-is so it doesn't render as "-".
                  const val = COUNTRY_JSON[key.toUpperCase()] || key || "-";
                  const v = toAudiencePercent(value);
                  return <Box sx={{ width: 'calc(50% - 10px)' }} key={i}><LinearProgressWithLabel value={v} country={val} /></Box>
                }) : <span>No Data Found</span>)}
              </Stack>
            </Box>}
          </Box>
          <Box id="content" paddingTop={"60px"}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              <img src={imageIcon} style={{ width: '24px', height: '24px' }} alt={imageIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Content</Typography>
            </Stack>
            <Stack direction={"row"} gap={1} alignItems={"center"} paddingTop={"40px"}>
              <Typography fontSize={16} fontWeight={400} color={"#726C6C"}>HASHTAGS</Typography>
            </Stack>
            <Grid container paddingTop={"16px"}>
              {
                (Array.isArray(deduplicatedHashtags) ? [...deduplicatedHashtags].sort((a, b) => b.value - a.value).slice(0, showAllHastags ? 26 : 11) : []).map((item, index) => (
                  <Grid key={item?.text + index} item xs={4} sx={{ height: '50px', padding: '0 30px 0 0' }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #F0F0F0', paddingY: '20px', height: '100%' }}>
                      <Stack direction="row" gap={1} alignItems='center'>
                        <Typography fontSize="16px" fontWeight={400}>{index + 1}.</Typography>
                        <Typography fontSize="16px" fontWeight={400}>{item?.text}</Typography>
                      </Stack>
                      <Typography color="#9F9C9C" fontSize="14px" fontWeight={400}>{item?.value ? `${item.value} Post` : ''}</Typography>
                    </Stack>
                  </Grid>
                ))
              }
              {deduplicatedHashtags?.length > 11 && <Grid item xs={4} sx={{ height: '50px', padding: 0 }}>
                <Stack direction="row" justifyContent="flex-end" alignItems="center" sx={{ paddingY: '20px', height: '100%', borderBottom: '1px solid #F0F0F0' }}>
                  <Button onClick={() => setShowAllHastags(prev => !prev)} disableRipple sx={{ "&:hover": { background: 'none' } }}>
                    <Typography sx={{ fontSize: "16px", fontWeight: 400, color: 'var(--color-blue)' }}>
                      {showAllHastags ? "See Less" : "See All"}
                    </Typography>
                  </Button>
                </Stack>
              </Grid>}
              {deduplicatedHashtags?.length === 0 && (
                <Grid item xs={12} sx={{ padding: '20px 0' }}>
                  <Typography fontSize={14} fontWeight={400} color={"#726C6C"}>No hashtag data available</Typography>
                </Grid>
              )}
            </Grid>
            <Box paddingTop={"40px"}>
              <Typography fontSize={16} fontWeight={400} color={"#726C6C"} paddingBottom={"16px"}>TOP POSTS</Typography>
              {data?.content?.[postTab]?.length > 0 ? <>
                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} paddingBottom={"16px"}>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', border: '1px solid #EEE', padding: '4px', borderRadius: '4px' }}>
                    <Stack direction="row" spacing={1}>
                      <Button onClick={() => setPostTab("topMostPost")} sx={{
                        color: postTab === "topMostPost" ? "white" : 'black', background: postTab === "topMostPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                      }}><Typography fontSize={12} fontWeight={500} color={postTab === "topMostPost" ? "white" : 'black'}>Top Posts</Typography></Button>
                      <Button onClick={() => setPostTab("topRecentPost")} sx={{
                        color: postTab === "topRecentPost" ? "white" : 'black', background: postTab === "topRecentPost" ? "var(--color-blue)" : 'white', borderRadius: '4px', "&:hover": { background: 'var(--color-blue)', "& p": { color: 'white' } }
                      }}><Typography fontSize={12} fontWeight={500} color={postTab === "topRecentPost" ? "white" : 'black'}>Recent Posts</Typography></Button>
                    </Stack>
                  </Box>
                </Stack>
                <Carousel responsive={responsive} itemClass="carousel-item-padding-40-px">
                  {data.content[postTab].slice(0, 12).map((post, index) => (
                    <Box key={post.id || index} sx={{ width: '280px', borderRadius: '4px', overflow: 'hidden', cursor: post.shortcode ? 'pointer' : 'default' }}
                      onClick={() => { if (post.shortcode) window.open(post.shortcode, "_blank"); }}>
                      <Box sx={{ width: '100%', height: '240px', overflow: 'hidden', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {post.media_type === 2 ? (
                          <video src={post.thumbnailSrc} style={{ width: '100%', height: '100%', objectFit: 'cover' }} muted preload="metadata" />
                        ) : post.thumbnailSrc ? (
                          <img src={post.thumbnailSrc} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = '<span style="color:#999;font-size:12px">Media</span>'; }} />
                        ) : (
                          <Typography fontSize={12} color={"#999"}>No preview</Typography>
                        )}
                      </Box>
                      <Stack sx={{ height: '10%', width: '100%', background: 'black', borderRadius: '0 0 4px 4px', padding: '8px' }} justifyContent={"space-between"} alignItems={"center"} direction={"row"}>
                        <Stack direction={"row"} gap={1} justifyContent={"flex-start"} alignItems={"center"}>
                          <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                            <img src={likeIcon} alt="likes" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                            <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.previewLikeCount)}</Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                            <img src={eyeIcon} alt="views" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                            <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.viewCount)}</Typography>
                          </Stack>
                          <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                            <img src={profileCommentIcon} alt="comments" style={{ filter: 'brightness(0) invert(1)', height: '14px', width: '14px' }} />
                            <Typography fontSize={11} fontWeight={500} color={'white'}>{getFixedValue(post.commentCount)}</Typography>
                          </Stack>
                        </Stack>
                        <Typography fontSize={11} fontWeight={500} color={"white"}>{getDateformatUsingSeconds(post.timestamp)}</Typography>
                      </Stack>
                    </Box>
                  ))}
                </Carousel>
              </> : <Box sx={{ padding: '20px', border: '1px solid #F0F0F0', borderRadius: '8px', textAlign: 'center' }}>
                <Typography fontSize={14} fontWeight={400} color={"#726C6C"}>No posts data available</Typography>
              </Box>}
            </Box>
          </Box>
          <Box id="growth" paddingTop={"60px"}>
            <Stack direction={"row"} gap={1} alignItems={"center"} marginBottom="40px">
              <img src={growthIcon} style={{ width: '24px', height: '24px' }} alt={growthIcon} />
              <Typography fontSize={20} fontWeight={600} color={"black"}>Growth</Typography>
            </Stack>
            <Stack sx={{ width: "100%", flexWrap: "wrap", gap: "16px" }} direction={"row"}>
              <Box sx={{ height: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', width: "calc(50% - 8px)" }}>
                <Typography fontSize={16} fontWeight={500} color={"black"} paddingBottom={'15px'} display="flex" alignItems="center" gap={1}>
                  30D FOLLOWERS GROWTH RATE
                  <Tooltip arrow title="30D followers growth rate is a measure of how many new followers an influencer has gained or lost over a period of 30 days, expressed as a percentage." componentsProps={TOOLTIP_STYLES}>
                    <img src={infoIcon} style={{ width: '20px', height: '20px' }} alt="" />
                  </Tooltip>
                </Typography>
                <Typography fontSize={16} fontWeight={700} color={"black"}>{getGrowthRate()}</Typography>
              </Box>
              <Box sx={{ height: '100%', padding: '20px', border: '1px solid #EEE', borderRadius: '12px', width: "calc(50% - 8px)" }}>
                <Typography fontSize={16} fontWeight={500} color={"black"} paddingBottom={'15px'} display="flex" alignItems="center" gap={1}>
                  30D FOLLOWERS GAIN
                  <Tooltip arrow title="30D followers gain shows the total number of followers this influencer gained or lost over a period of 30 days." componentsProps={TOOLTIP_STYLES}>
                    <img src={infoIcon} style={{ width: '20px', height: '20px' }} alt="" />
                  </Tooltip>
                </Typography>
                <Typography fontSize={16} fontWeight={700} color={"black"}>{getFixedValue(data?.Audience?.monthGain) || "N/A"}</Typography>
              </Box>
            </Stack>
          </Box>
          <Box id="brands" paddingTop={"60px"}>
            <Brands brands={data?.Brands} handleId={data?.handleRecordId} userId={data?.userId} />
          </Box>
        </Box>
      </Stack>
    </>
  )
}

export default UltimateSocialProfileSummary;